import React, { useState } from "react";
import { Form, Row, Col, Modal, Button as But } from "antd";
import DropDown from "../components/ReportFormGenerator/DropDown/DropDown";
import TextBox from "../components/ReportFormGenerator/TextBox/TextBox";
import Button from "../components/ReportFormGenerator/Button/Button";
import Idame from "../components/ReportFormGenerator/Idame/Idame";

function TrainingEffective(props) {
  const [form] = Form.useForm();
  props.setPageHeader("Training Effective");
  const numOption = [
    {
      value: 0,
      label: 0,
    },
    {
      value: 1,
      label: 1,
    },
    {
      value: 2,
      label: 2,
    },
    {
      value: 3,
      label: 3,
    },
    {
      value: 4,
      label: 4,
    },
    {
      value: 5,
      label: 5,
    },
    {
      value: 6,
      label: 6,
    },
    {
      value: 7,
      label: 7,
    },
    {
      value: 8,
      label: 8,
    },
    {
      value: 9,
      label: 9,
    },
    {
      value: 10,
      label: 10,
    },
  ];
  const yesNoOption = [
    { label: "Yes", value: "Yes" },
    { label: "No", value: "No" },
  ];
  const justify = "center";

  const [modelvisible, setModalVisible] = useState(false);

  const onFinish = (values) => {
    setModalVisible(true);
  };

  return (
    <>
      <Modal
        centered
        title={<h5 style={{ color: "#fff", margin: 0 }}>Success</h5>}
        open={modelvisible}
        onCancel={() => setModalVisible(false)}
        footer={null}
      >
        <h6 style={{ color: "#fff" }}>✔️ Sucessfully Submitted to HRA</h6>
        <div style={{ textAlign: "right", marginTop: "10px" }}>
          <But
            type="primary"
            onClick={() => setModalVisible(false)}
            style={{
              textAlign: "center",
              border: "none",
              fontWeight: "600",
            }}
          >
            OK
          </But>
        </div>
      </Modal>
      <div className="AuditSection CreateAudit" style={{ padding: "10px" }}>
        <div className="ThemeForm">
          <Form
            name="ReportForm"
            form={form}
            labelCol={{ span: 8 }}
            wrapperCol={{ span: 16 }}
            layout="horizontal"
            colon={false}
            onFinish={onFinish}
            size="large"
          >
            <Row gutter={24} justify={justify}>
              <Col span={12}>
                <DropDown
                  name="training"
                  label="Training"
                  required={true}
                  errorMessage="Please Select Training"
                  placeholder="Select Training"
                  searchable={true}
                  options={[
                    {
                      value: "TPM",
                      label: "TPM Trg -2020/11/03 - Ashish Bhat",
                    },
                    { value: "5S", label: "5S  Trg -2020/11/03 - Megha Sutar" },
                    {
                      value: "6S",
                      label: "Six Sigma Trg -2020/11/03 - Manish Kumar",
                    },
                    {
                      value: "FN",
                      label:
                        "Finance For Non Fin Trg -2020/11/03 - Jacob Thomas",
                    },
                    {
                      value: "EE",
                      label: "Email Etiquetes Trg -2020/11/03 - Sampit Joshi",
                    },
                    {
                      value: "TR",
                      label: "Taxation Rules Trg -2020/11/03 - Shalini Jaiswal",
                    },
                  ]}
                />
              </Col>
            </Row>
            <Row gutter={24} justify={justify}>
              <Idame
                form={form}
                type="name"
                url="/mdict"
                urlData={{ typ: "Associate", subTyp: "idame" }}
                idName="name"
                nameName="Name"
                nameLabel="Name"
                nameErrorMessage="Please Select Name"
                nameRequired={true}
                namePlaceholder="Select Name"
              />
            </Row>
            <Row gutter={24} justify={justify}>
              <Col span={12}>
                <DropDown
                  name="Q1"
                  labelColSpan={18}
                  label="Sharing of learning / knowledge from training to other employee"
                  required={true}
                  errorMessage="Please Select a Value"
                  searchable={true}
                  options={numOption}
                />
              </Col>
            </Row>
            <Row gutter={24} justify={justify}>
              <Col span={12}>
                <DropDown
                  name="Q2"
                  labelColSpan={18}
                  label="How much new skills/knowledge gained was utilised."
                  required={true}
                  errorMessage="Please Select a Value"
                  searchable={true}
                  options={numOption}
                />
              </Col>
            </Row>
            <Row gutter={24} justify={justify}>
              <Col span={12}>
                <DropDown
                  name="Q3"
                  label="Objective met"
                  labelColSpan={18}
                  required={true}
                  errorMessage="Please Select a Value"
                  searchable={true}
                  options={numOption}
                />
              </Col>
            </Row>
            <Row gutter={24} justify={justify}>
              <Col span={12}>
                <DropDown
                  name="Q4"
                  label="Required Competency Achieved"
                  labelColSpan={18}
                  required={true}
                  errorMessage="Please Select a Option"
                  searchable={true}
                  options={yesNoOption}
                />
              </Col>
            </Row>
            <Row gutter={24} justify={justify}>
              <Col span={12}>
                <DropDown
                  name="Q5"
                  label="Is Refresher Training Rqd"
                  labelColSpan={18}
                  required={true}
                  errorMessage="Please Select a Option"
                  searchable={true}
                  options={yesNoOption}
                />
              </Col>
            </Row>
            <Row gutter={24} justify={justify}>
              <Col span={12}>
                <DropDown
                  name="Q6"
                  label="Is Training faculty Agency need to be 
                  changed"
                  labelColSpan={18}
                  required={true}
                  errorMessage="Please Select a Option"
                  searchable={true}
                  options={yesNoOption}
                />
              </Col>
            </Row>
            <Row gutter={24} justify={justify}>
              <Col span={12}>
                <TextBox
                  form={form}
                  type="textarea"
                  name="HOD"
                  label="HOD Comment"
                  required={false}
                  errorMessage="Please Enter Comments"
                  maxChar={400}
                  maxCharErrorMessage="Accepted only 400 Chars"
                />
              </Col>
            </Row>
            <Row gutter={24} justify={justify}>
              <Col span={12}>
                <TextBox
                  form={form}
                  type="textarea"
                  disabled={true}
                  name="HRA"
                  label="HRA Comment"
                  required={false}
                  errorMessage="Please Enter Comments"
                  maxChar={400}
                  maxCharErrorMessage="Accepted only 400 Chars"
                />
              </Col>
            </Row>
            <Row gutter={24} justify={justify}>
              <Col span={12} style={{ marginLeft: "-70px" }}>
                <Button
                  form={form}
                  cancelButtonText={"Cancel"}
                  submitButtonText={"Submit"}
                  resetButton={true}
                />
              </Col>
            </Row>
          </Form>
        </div>
      </div>
    </>
  );
}

export default TrainingEffective;
